var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import './copy-button.shape';
import { attr } from '@exadel/esl/modules/esl-utils/decorators';
import { UIPPluginButton } from '../../core/button/plugin-button';
/** Button-plugin to copy snippet to clipboard */
export class UIPCopy extends UIPPluginButton {
    /** Content to copy */
    get content() {
        var _a;
        if (this.source === 'js' || this.source === 'html')
            return (_a = this.model) === null || _a === void 0 ? void 0 : _a[this.source];
    }
    connectedCallback() {
        if (!navigator.clipboard)
            this.hidden = true;
        super.connectedCallback();
    }
    onAction() {
        this.copy().then(() => this.dispatchMessage());
    }
    /** Dispatches success alert message */
    dispatchMessage() {
        const detail = this.constructor.msgConfig;
        this.$$fire('esl:alert:show', { detail });
    }
    /** Copy model content to clipboard */
    copy() {
        return navigator.clipboard.writeText(this.content || '');
    }
}
UIPCopy.is = 'uip-copy';
UIPCopy.defaultTitle = 'Copy to clipboard';
UIPCopy.msgConfig = {
    text: 'Playground content copied to clipboard',
    cls: 'uip-copy-alert'
};
__decorate([
    attr({ defaultValue: 'html' })
], UIPCopy.prototype, "source", void 0);
